<template>
  <div>
    <p
      v-if="instructionsText"
      :class="$style.instructions"
    >
      {{ instructionsText }}
    </p>
    <ul>
      <li
        v-for="(step, index) in instructionLinkSteps"
        :key="index"
        :class="$style.step"
      >
        {{ step.startText }}
        <Link
          :href="step.kbLink"
          target="_blank"
          :text="step.linkText"
        />
        {{ step.endText }}
      </li>
    </ul>
    <p
      v-if="instructionStepsSummary"
      :class="$style.instructions"
    >
      {{ instructionStepsSummary.startText }}
      <Link
        :href="instructionStepsSummary.kbLink"
        target="_blank"
        :text="instructionStepsSummary.linkText"
      />
      {{ instructionStepsSummary.endText }}
    </p>
    <CapabilitiesList
      v-if="capabilities.length"
      :capabilities="capabilities"
    />
    <div :class="$style.btnContainer">
      <IconButton
        ref="downloadButton"
        :href="agentUrl"
        icon="fileDownload"
        target="_blank"
        :text="downloadButtonText"
        @click="triggerClickAgentButtonEvent(system)"
      />
      <CopyWell
        :content="agentUrl"
        hideTextarea
        label="Copy Download Link"
        :location="copyWellLocation"
      />
      <CopyWell
        :content="copyWell.content"
        :label="copyWell.label"
        :location="`Create System - ${copyWell.label}`"
        :rows="copyWell.rows"
        :showTooltip="copyWell.showTooltip"
        :tooltipLabel="copyWell.tooltipLabel"
        @copyToClipboard="logSystemAdded"
      />
    </div>

    <CompatibilityNotes
      v-if="compatibilityNotes"
      :compatibilityNotes="compatibilityNotes"
    />
  </div>
</template>
<script>
import {
  IconButton, Link,
} from '@jumpcloud/ui-components';
import { mapActions } from 'vuex';
import { onboardingTasks } from 'client/GrowthEngineering/utilities/GrowthConstants';
import CapabilitiesList from 'client/systems/CapabilitiesList.vue';
import CompatibilityNotes from 'client/systems/CompatibilityNotes.vue';
import CopyWell from 'client/components/FormValidation/CopyWell.vue';
import CreateSystemMixin from 'client/systems/CreateSystemMixin';
import EventManager from 'client/GrowthEngineering/EventManager';

const onboardingModule = 'OnboardingModule';

export default {
  name: 'AgentInstructions',

  components: {
    CapabilitiesList,
    CompatibilityNotes,
    CopyWell,
    IconButton,
    Link,
  },

  mixins: [
    CreateSystemMixin,
  ],

  props: {
    agentUrl: {
      required: true,
      type: String,
    },
    capabilities: {
      type: Array,
      default: () => [],
    },
    compatibilityNotes: {
      type: Object,
      default() {
        return null;
      },
      validator(value) {
        if (!value) {
          return true;
        }

        return !!(value.header && value.text);
      },
    },
    connectKey: {
      required: true,
      type: String,
    },
    copyWell: {
      type: Object,
      default() {
        return null;
      },
      validator(value) {
        if (!value) {
          return true;
        }

        return !!(value.label
                  && value.content
                  && (value.rows ? typeof value.rows === 'number' : true));
      },
    },
    copyWellLocation: {
      default: '',
      type: String,
    },
    downloadButtonText: {
      default: '',
      type: String,
    },
    instructionLinkSteps: {
      default: () => [],
      type: Array,
      validate: steps => steps
        .every(step => step.startText && step.linkText && step.endText && step.kbLink),
    },
    instructionStepsSummary: {
      type: Object,
      default() {
        return null;
      },
      validator(value) {
        if (!value) {
          return true;
        }

        return value.startText && value.linkText && value.endText && value.kbLink;
      },
    },
    instructionsText: {
      default: '',
      type: String,
    },
    kickstart: {
      required: true,
      type: String,
    },
    system: {
      required: true,
      type: String,
    },
  },

  methods: {
    ...mapActions(onboardingModule, [
      'completeOnboardingTask',
    ]),

    logSystemAdded() {
      const { triggerSystemAdded } = EventManager;
      triggerSystemAdded(this.system.toLowerCase());
      this.completeOnboardingTask(onboardingTasks.discoverResources);
      this.completeOnboardingTask(onboardingTasks.systemCreated);
    },
  },
};
</script>
<style module>
@import './CreateSystem.css';

.instructions {
  padding-bottom: 10px;
}

.btnContainer {
  margin: var(--jc-spacer-large) 0;
}
</style>
